import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { PublicationsReducerActionType } from '../reducers/publicationsReducer';
import { ApiPublicationsResponseType } from '../features/Publications/types';
import { PUBLICATIONS_PER_PAGE } from '../features/Publications/PublicationList';
import {
  DELETE_PUBLICATION,
  LIST_PUBLICATIONS,
  ADD_PUBLICATION,
} from './publicationsActions';

export const listEvents =
  (page: number) =>
  (
    dispatch: Dispatch<PublicationsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get(
      `/back-office/publications?per_page=${PUBLICATIONS_PER_PAGE}&page=${page}`,
      (response: ApiPublicationsResponseType): void => {
        response.data &&
          dispatch({
            type: LIST_PUBLICATIONS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const addEvent =
  (body: any, successCallback: () => void, failureCallback: () => void) =>
  (
    dispatch: Dispatch<PublicationsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post, get },
    } = getState();

    post(
      '/events',
      body,
      (eventId: string) => {
        successCallback();
        get(
          `/events/${eventId}`,
          (response: ApiPublicationsResponseType): void => {
            dispatch({
              type: ADD_PUBLICATION,
              payload: response.data,
            });
          }
        );
      },
      () => failureCallback()
    );
  };

export const deleteEvent =
  (id: string, successCallback: () => void, failureCallback: () => void) =>
  (
    dispatch: Dispatch<PublicationsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/events/${id}`,
      {},
      () => {
        dispatch({ type: DELETE_PUBLICATION, payload: id });
        successCallback();
      },
      () => failureCallback()
    );
  };

export const updateEvent =
  (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<PublicationsReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/events/${id}`,
      body,
      () => {
        listEvents(1)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };
